import { memoize } from "lodash";
import { createPinia } from "pinia";
export const useAppPinia = memoize(() => {
    return createPinia();
});
